import Publication from './components';

export default Publication;
